import Fuse from 'fuse.js';
export const categoryList = retailCategories => retailCategories.filter(category => category.level === 1);
export const subCategoryList = (retailCategories, category) => {
  const categoryObj = retailCategories.filter(c => c.title === category)[0];
  return retailCategories.filter(item => item.parentId === categoryObj.id);
};
export const storesAcceptGiftCard = stores => {
  const paymentMethods = store => {
    var _store$retailer;
    return store.paymentMethods.length > 0 ? store.paymentMethods : ((_store$retailer = store.retailer) === null || _store$retailer === void 0 ? void 0 : _store$retailer.paymentMethods) || [];
  };
  return stores.filter(store => paymentMethods(store).indexOf('Westfield Giftcard') > -1);
};
export const storesMatchSearch = (stores, searchTerm) => {
  const options = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    keys: ['title']
  };
  return new Fuse(stores, options).search(searchTerm);
};
export const filterStores = (stores, query) => {
  let filteredStores = stores;
  const {
    searchTerm,
    giftCardAccepted
  } = query;
  if (searchTerm) {
    filteredStores = storesMatchSearch(filteredStores, searchTerm);
  }
  if (giftCardAccepted) {
    filteredStores = storesAcceptGiftCard(filteredStores);
  }
  return filteredStores;
};